import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _newArrowCheck from "@babel/runtime/helpers/newArrowCheck";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.create.js";
import $ from 'jquery';
var globalID = 1;
var pastWarnings = {};
var Utils = {
  // Parsley DOM-API
  // returns object from dom attributes and values
  attr: function attr(element, namespace, obj) {
    var i;
    var attribute;
    var attributes;
    var regex = new RegExp('^' + namespace, 'i');
    if ('undefined' === typeof obj) obj = {};else {
      // Clear all own properties. This won't affect prototype's values
      for (i in obj) {
        if (obj.hasOwnProperty(i)) delete obj[i];
      }
    }
    if (!element) return obj;
    attributes = element.attributes;
    for (i = attributes.length; i--;) {
      attribute = attributes[i];
      if (attribute && attribute.specified && regex.test(attribute.name)) {
        obj[this.camelize(attribute.name.slice(namespace.length))] = this.deserializeValue(attribute.value);
      }
    }
    return obj;
  },
  checkAttr: function checkAttr(element, namespace, _checkAttr) {
    return element.hasAttribute(namespace + _checkAttr);
  },
  setAttr: function setAttr(element, namespace, attr, value) {
    element.setAttribute(this.dasherize(namespace + attr), String(value));
  },
  getType: function getType(element) {
    return element.getAttribute('type') || 'text';
  },
  generateID: function generateID() {
    return '' + globalID++;
  },
  /** Third party functions **/
  deserializeValue: function deserializeValue(value) {
    var num;
    try {
      return value ? value == "true" || (value == "false" ? false : value == "null" ? null : !isNaN(num = Number(value)) ? num : /^[\[\{]/.test(value) ? JSON.parse(value) : value) : value;
    } catch (e) {
      return value;
    }
  },
  // Zepto camelize function
  camelize: function camelize(str) {
    return str.replace(/-+(.)?/g, function (match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
  },
  // Zepto dasherize function
  dasherize: function dasherize(str) {
    return str.replace(/::/g, '/').replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2').replace(/([a-z\d])([A-Z])/g, '$1_$2').replace(/_/g, '-').toLowerCase();
  },
  warn: function warn() {
    var _window$console;
    if (window.console && 'function' === typeof window.console.warn) (_window$console = window.console).warn.apply(_window$console, arguments);
  },
  warnOnce: function warnOnce(msg) {
    if (!pastWarnings[msg]) {
      pastWarnings[msg] = true;
      this.warn.apply(this, arguments);
    }
  },
  _resetWarnings: function _resetWarnings() {
    pastWarnings = {};
  },
  trimString: function trimString(string) {
    return string.replace(/^\s+|\s+$/g, '');
  },
  parse: {
    date: function date(string) {
      var _this = this;
      var parsed = string.match(/^(\d{4,})-(\d\d)-(\d\d)$/);
      if (!parsed) return null;
      var _parsed$map = parsed.map(function (x) {
          _newArrowCheck(this, _this);
          return parseInt(x, 10);
        }.bind(this)),
        _parsed$map2 = _slicedToArray(_parsed$map, 4),
        _ = _parsed$map2[0],
        year = _parsed$map2[1],
        month = _parsed$map2[2],
        day = _parsed$map2[3];
      var date = new Date(year, month - 1, day);
      if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) return null;
      return date;
    },
    string: function string(_string) {
      return _string;
    },
    integer: function integer(string) {
      if (isNaN(string)) return null;
      return parseInt(string, 10);
    },
    number: function number(string) {
      if (isNaN(string)) throw null;
      return parseFloat(string);
    },
    'boolean': function _boolean(string) {
      return !/^\s*false\s*$/i.test(string);
    },
    object: function object(string) {
      return Utils.deserializeValue(string);
    },
    regexp: function regexp(_regexp) {
      var flags = '';

      // Test if RegExp is literal, if not, nothing to be done, otherwise, we need to isolate flags and pattern
      if (/^\/.*\/(?:[gimy]*)$/.test(_regexp)) {
        // Replace the regexp literal string with the first match group: ([gimy]*)
        // If no flag is present, this will be a blank string
        flags = _regexp.replace(/.*\/([gimy]*)$/, '$1');
        // Again, replace the regexp literal string with the first match group:
        // everything excluding the opening and closing slashes and the flags
        _regexp = _regexp.replace(new RegExp('^/(.*?)/' + flags + '$'), '$1');
      } else {
        // Anchor regexp:
        _regexp = '^' + _regexp + '$';
      }
      return new RegExp(_regexp, flags);
    }
  },
  parseRequirement: function parseRequirement(requirementType, string) {
    var converter = this.parse[requirementType || 'string'];
    if (!converter) throw 'Unknown requirement specification: "' + requirementType + '"';
    var converted = converter(string);
    if (converted === null) throw "Requirement is not a ".concat(requirementType, ": \"").concat(string, "\"");
    return converted;
  },
  namespaceEvents: function namespaceEvents(events, namespace) {
    var _this2 = this;
    events = this.trimString(events || '').split(/\s+/);
    if (!events[0]) return '';
    return $.map(events, function (evt) {
      _newArrowCheck(this, _this2);
      return "".concat(evt, ".").concat(namespace);
    }.bind(this)).join(' ');
  },
  difference: function difference(array, remove) {
    var _this3 = this;
    // This is O(N^2), should be optimized
    var result = [];
    $.each(array, function (_, elem) {
      _newArrowCheck(this, _this3);
      if (remove.indexOf(elem) == -1) result.push(elem);
    }.bind(this));
    return result;
  },
  // Alter-ego to native Promise.all, but for jQuery
  all: function all(promises) {
    // jQuery treats $.when() and $.when(singlePromise) differently; let's avoid that and add spurious elements
    return $.when.apply($, _toConsumableArray(promises).concat([42, 42]));
  },
  // Object.create polyfill, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create#Polyfill
  objectCreate: Object.create || function () {
    var Object = function Object() {};
    return function (prototype) {
      if (arguments.length > 1) {
        throw Error('Second argument not supported');
      }
      if (_typeof(prototype) != 'object') {
        throw TypeError('Argument must be an object');
      }
      Object.prototype = prototype;
      var result = new Object();
      Object.prototype = null;
      return result;
    };
  }(),
  _SubmitSelector: 'input[type="submit"], button:submit'
};
export default Utils;